'use client';

import { useRouter } from 'next/navigation';
import { Home, BarChart2, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface Props {
  active: 'home' | 'stats' | 'profile';
}

const NAV_ITEMS = [
  { id: 'home' as const, label: 'Główna', icon: Home, href: '/home-screen' },
  { id: 'stats' as const, label: 'Statystyki', icon: BarChart2, href: '/stats-view' },
  { id: 'profile' as const, label: 'Profil', icon: User, href: '/profile-management' },
];

export default function AppBottomNav({ active }: Props) {
  const router = useRouter();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-[hsl(var(--card)/0.95)] backdrop-blur-md border-t border-[hsl(var(--border))] safe-bottom">
      <div className="flex items-center justify-around px-4 pt-2 pb-1 max-w-sm mx-auto">
        {NAV_ITEMS.map(({ id, label, icon: Icon, href }) => {
          const isActive = active === id;
          return (
            <button
              key={`nav-${id}`}
              onClick={() => router.push(href)}
              className={`flex flex-col items-center gap-1 px-4 py-1.5 rounded-xl transition-all duration-150 active:scale-90 ${
                isActive
                  ? 'text-[hsl(var(--primary))]'
                  : 'text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]'
              }`}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 1.8} />
              <span className={`text-[10px] font-medium ${isActive ? 'font-semibold' : ''}`}>
                {label}
              </span>
              {isActive && (
                <span className="absolute bottom-[calc(env(safe-area-inset-bottom,0px)+2px)] w-1 h-1 rounded-full bg-[hsl(var(--primary))]" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}